<div class="orders-report-page">
  <app-orders-report-header
    [resultCount]="filteredRows.length"
    [loadedCount]="loadedCount"
    [activeFilterCount]="activeFilterCount"
    [isLoading]="isBusy"
    [isLoadingMore]="isLoadingMore"
    (refresh)="loadOrders()"
  ></app-orders-report-header>

  <app-orders-report-filters
    [filters]="filters"
    [filterOptions]="filterOptions"
    [activeFilterChips]="activeFilterChips"
    [disabled]="isInitialLoading"
    (filtersChange)="onFiltersChange($event)"
    (clearAll)="onClearFilters()"
    (removeFilter)="onRemoveFilter($event)"
  ></app-orders-report-filters>

  <app-orders-report-table
    [rows]="filteredRows"
    [isLoading]="isInitialLoading"
    [isLoadingMore]="isLoadingMore"
    [loadedCount]="loadedCount"
    [totalCount]="filteredRows.length"
    (openPdf)="onOpenPdf($event)"
  ></app-orders-report-table>
</div>
